import * as actionTypes from "../actions/actionTypes";
import moment from "moment";
import { formatDate } from "../../utils/constants";

const initialState = {
  selectedDate: formatDate(new Date()),
  isExternalUserLoggedIn: false,
  externalUserLoginDetails: {
    email: "",
    password: "",
  },
};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.UPDATE_SELECTED_DATE:
      return { ...state, selectedDate: action.val };

    case actionTypes.UPDATE_EXTERNAL_USER_LOGIN:
      return {
        ...state,
        isExternalUserLoggedIn: action.val.isExternalUserLoggedIn,
        externalUserLoginDetails: action.val.externalUserLoginDetails,
      };
  }
  return state;
}
